import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaw } from '@fortawesome/free-solid-svg-icons'

export let values = [
    {
        title: 'safety',
        icon: <FontAwesomeIcon icon={faPaw} size="2xl"/>,
        info: 'From properly trained staff, to small play groups, and a well maintained facility, safety is always our first priority'
    },
    {
        title: 'cleanliness',
        icon: <FontAwesomeIcon icon={faPaw} size="2xl"/>,
        info: 'We work continuously to provide a clean, well sanitized environment for your pet.  All laundry, dishes, sleeping suites, indoor play areas and outside play space are cleaned routinely throughout the day for maximum cleanliness.'
    },
    {
        title: 'comfort',
        icon: <FontAwesomeIcon icon={faPaw} size="2xl"/>,
        info: 'Bringing your pet all of the comforts of home is essential.  That’s why fluffy bedding, toys, tv time, inside and outside play time, and tons of human love, interaction and snuggles are always a part of their time with us.'
    },
    {
        title: 'fun',
        icon: <FontAwesomeIcon icon={faPaw} size="2xl"/>,
        info: ' Whether it’s running with the ball or playing with their friends or splashing in the pool, the best part of our day is watching your pet have the time of their life.'
    },
]
